import React from 'react'
import './Waves.css'
import { useAppSelector } from '../../store/reducers/store'
import { hexToRgbA } from '../../utility/utils'

const Waves: React.FC = () => {
    const data = useAppSelector((data) => data.data)

    return data.currentInstance && data.currentInstance.keys ? (
        <>
            <div>
                <svg className="waves" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                    <defs>
                        <path
                            id="gentle-wave"
                            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                        />
                    </defs>
                    <g className="parallax">
                        <use
                            xlinkHref="#gentle-wave"
                            x="48"
                            y="4"
                            fill={hexToRgbA(data.currentInstance.keys.graphics.palette.primary, 0.7)}
                        />
                        <use
                            xlinkHref="#gentle-wave"
                            x="48"
                            y="3"
                            fill={hexToRgbA(data.currentInstance.keys.graphics.palette.primary, 0.5)}
                        />
                        <use
                            xlinkHref="#gentle-wave"
                            x="48"
                            y="5"
                            fill={hexToRgbA(data.currentInstance.keys.graphics.palette.primary, 0.3)}
                        />
                        <use
                            xlinkHref="#gentle-wave"
                            x="48"
                            y="7"
                            fill={hexToRgbA(data.currentInstance.keys.graphics.palette.primary, 0.1)}
                        />
                    </g>
                </svg>
            </div>
        </>
    ) : null
}

export default Waves
